import React, { useState, useReducer } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setMessageHandler } from "../../../reducers/selectedValues";
import { Grid } from "@mui/material";
import { InputDate } from "../../uiControls/inputDate";
import { TableWithStickyHeader } from "../../uiControls/tableWithStickyHeader";
import { AddNew } from "../../uiControls/addNew";
import * as utils from "../../common/utils";

const importStatusColumns = [
  {
    label: "Batch",
    keyField: "facilitykey",
    dataField: "batch",
    dataType: "number",
  },
  {
    label: "Import Date",
    keyField: "facilitykey",
    dataField: "importdate",
    dataType: "date",
  },
  {
    label: "File Type",
    keyField: "facilitykey",
    dataField: "filetype",
    dataType: "string",
  },
  {
    label: "File Name",
    keyField: "facilitykey",
    dataField: "fileName",
    dataType: "string",
  },
  {
    label: "File Details",
    keyField: "facilitykey",
    dataField: "fileDetails",
    dataType: "string",
  },
  {
    label: "Total Records",
    keyField: "facilitykey",
    dataField: "totalRecords",
    dataType: "number",
  },
  {
    label: "Processed Records",
    keyField: "facilitykey",
    dataField: "processedRecords",
    dataType: "number",
  },
  {
    label: "Email Contact",
    keyField: "facilitykey",
    dataField: "emailContacts",
    dataType: "string",
  },
  {
    label: "File Status",
    keyField: "facilitykey",
    dataField: "fileStatus",
    dataType: "string",
  },
  {
    label: "System Status",
    keyField: "facilitykey",
    dataField: "systemStatus",
    dataType: "string",
  },
  {
    label: "Error in Previous Run",
    keyField: "facilitykey",
    dataField: "errorinPreviousRun",
    dataType: "string",
  },
];

const importStatusSearchColumns = [
  "importdate",
  "filetype",
  "fileName",
  "emailContacts",
  "fileStatus",
  "systemStatus",
  "errorinPreviousRun",
];

const initialImportStatusDetails = {
  startDate: null,
  endDate: null,
};

export const ImportStatus = () => {
  const facilityId = useSelector((state) => state.SelectedValues.facilityId);
  const messageDispatch = useDispatch();
  const [loadData, setLoadData] = useState(true);
  const [importStatusDetails, setImportStatusDetails] = useReducer(
    (state, updates) => ({ ...state, ...updates }),
    initialImportStatusDetails
  );

  const updateImportStatusDetailsValue = (_key, value) => {
    setImportStatusDetails({ [_key]: value });
    if (value) {
      messageDispatch(setMessageHandler({ type: null, message: null }));
    }
  };

  const onDateChangeHandler = (e, controlName) => {
    updateImportStatusDetailsValue(controlName, e);
  };

  const getUrl = (params) => {
    setLoadData(true);
    return (
      "DataSources/Import/Status?facilityKey=" +
      (facilityId ? facilityId : 0) +
      "&startDate=" +
      utils.formatDateUS(importStatusDetails.startDate) +
      "&endDate=" +
      utils.formatDateUS(importStatusDetails.endDate)
    );
  };

  return (
    <div
      style={{ display: "flex", gap: "20px", height: "calc(100vh - 160px)" }}
    >
      <div
        style={{
          display: "flex",
          flexFlow: "column",
          width: "100%",
        }}
      >
        <Grid container sx={{ display: "flex", gap: "15px" }}>
          <Grid item xs={3} sx={{ display: "flex" }}>
            <div style={{ display: "flex" }}>
              <b>Start Date:</b> &nbsp;
              <div style={{ width: "75%" }}>
                <InputDate
                  label=""
                  id={"importStatusDetails.startDate"}
                  value={importStatusDetails.startDate}
                  onChange={(e) => onDateChangeHandler(e, "startDate")}
                  isRequired={false}
                  isError={importStatusDetails.startDate === ""}
                  displayType={"inline"}
                />
              </div>
            </div>
          </Grid>
          <Grid item xs={1} sx={{ display: "flex" }}></Grid>
          <Grid item xs={3} sx={{ display: "flex" }}>
            <div style={{ display: "flex" }}>
              <b>End Date:</b> &nbsp;
              <div style={{ width: "75%" }}>
                <InputDate
                  label=""
                  id={"importStatusDetails.endDate"}
                  value={importStatusDetails.endDate}
                  onChange={(e) => onDateChangeHandler(e, "endDate")}
                  isRequired={false}
                  isError={importStatusDetails.endDate === ""}
                  displayType={"inline"}
                />
              </div>
            </div>
          </Grid>
          <Grid item xs={1} sx={{ display: "flex" }}></Grid>
          <Grid item xs={3} sx={{ display: "flex" }}>
            <AddNew
              onClickCall={() => {
                setLoadData(false);
              }}
              title={"Load"}
            />
          </Grid>
        </Grid>
        <TableWithStickyHeader
          pagging={false}
          columns={importStatusColumns}
          url={getUrl}
          sourceObj="statuses"
          editHandler={() => {}}
          updateOpen={loadData}
          searchOnColumns={importStatusSearchColumns}
          changeStatus={() => {}}
          searchPlace="left"
        />
      </div>
    </div>
  );
};
